module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAAM1BMVEUAAACZi4iai4elloelmpiZioiZioiZioiai4mai4iaioeajoqdkImhjo6Zi4eaioeZioeof2OFAAAAEHRSTlMA8toRCr7Lr3llYD8nG+W1SaJyIQAAAI9JREFUGNN1kVkOgzAMRG3HWQkw9z9tSzsIFMnvI4qeookX+ZNGNVWrI8mDNwXR5kL2AuQ+3WfPQNlpD9gmZDMcP+8F+ZWYMsqV02C09Ib2PRVMOE/mQJMMZD4DeMkYUtFX3VHFMFc9YaLwVTs00O+Qi5Mhz5cH9fUlCyRPgWyH3O0EzQejCgYbrCFYWrDiD1WwCG8Y8TcZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/time_default.png
// module id = ZLrK
// module chunks = 12